import { useAllInjections } from 'inversify-react';
import React, { Fragment } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ExternalRedirect } from 'infrastructure/targets/web/common/ExternalRedirect';
import { MobileDeeplink } from 'infrastructure/targets/web/common/MobileDeeplink.view';
import PageChangeListener from 'infrastructure/targets/web/common/PageChangeListener';
import ScrollTop from 'infrastructure/targets/web/common/ScrollTop';
import { AppHelmet } from 'infrastructure/targets/web/providers/AppHelmet';
import IWebModule, { WebModule } from 'infrastructure/targets/web/types/IWebModule';

const Router: React.FC = () => {
  const modules = useAllInjections<IWebModule>(WebModule);

  return (
    <BrowserRouter>
      <AppHelmet />
      <ScrollTop />
      <PageChangeListener />
      <Routes>
        {modules.map((m, idx) => (
          <Fragment key={idx}>{m.getRoutes()}</Fragment>
        ))}

        <Route path="mobile-app" element={<MobileDeeplink />} />
        <Route
          path="membership"
          element={<ExternalRedirect to="https://fiveirongolf.com/membership/" />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
